import profileApi from "../api/profile"
import useApiSource from "./useApiSource"

const useDeveloperApps = () => {
    const {data, setData} = useApiSource(profileApi.getApps.bind(profileApi))

    return {apps: data, setApps: setData}
}

export default useDeveloperApps